export default "__VITE_ASSET__C3ctY1Yz__"